import React from 'react';
import Hero from './components/administration/deans-students-welfare/Hero';
import Main from './components/administration/deans-students-welfare/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const DeansStudentsWelfare = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default DeansStudentsWelfare;